//@flow
import * as Immutable from 'immutable';

import { FpPjPlan, FpPlanAuditMetadata } from 'common/models/flow/FpPjPlan';
import type {
    FpPjPlanModelType,
    FpPlanAuditMetadataModelType
} from 'common/models/flow/FpPjPlan';
import { FpOutletVisit } from './FpOutletVisit';
import { FpSalesbeatPlan } from './FpSalesbeatPlan';

import { PlanStatusEnum } from 'common/enums/PlanEnums';

class InternalFpPjPlan extends FpPjPlan {
    static fromJS(json: FpPjPlanModelType): InternalFpPjPlan {
        const state: Object = Object.assign({}, json);
        state.auditMetadata = InternalFpPlanAuditMetadata.fromJS(
            state.auditMetadata
        );
        state.customProperties = Immutable.Map(state.customProperties);
        state.outletVisits = Immutable.List(state.outletVisits).map(item =>
            FpOutletVisit.fromJS(item)
        );
        state.salesbeatPlan = state.salesbeatPlan
            ? FpSalesbeatPlan.fromJS(state.salesbeatPlan)
            : state.salesbeatPlan;
        state.statusUpdates = Immutable.List(state.statusUpdates);
        state.progress = Immutable.List(state.progress);
        state.notes = Immutable.List(state.notes);
        return new this(Immutable.Map(state));
    }

    get auditMetadata(): InternalFpPlanAuditMetadata {
        return this._state.get('auditMetadata');
    }

    get outletVisits(): Immutable.List<FpOutletVisit> {
        return this._state.get('outletVisits');
    }

    get salesbeatPlan(): ?FpSalesbeatPlan {
        return this._state.get('salesbeatPlan');
    }

    get planStatus(): PlanStatusEnum {
        return this._state.get('planStatus');
    }
}

class InternalFpPlanAuditMetadata extends FpPlanAuditMetadata {
    static fromJS(
        json: FpPlanAuditMetadataModelType
    ): InternalFpPlanAuditMetadata {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalFpPjPlan as FpPjPlan,
    InternalFpPlanAuditMetadata as FpPlanAuditMetadata
};
